"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/stock-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fstock-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockTestApiServiceClient = exports.CloseStockAccountResponse = exports.CloseStockAccountRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const stock_testing_service_1 = require("../stock/testing/stock-testing-service");
const protobufPackage = 'com.step.testapi.proto';
function createBaseCloseStockAccountRequest() {
    return { userId: '' };
}
exports.CloseStockAccountRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.CloseStockAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCloseStockAccountRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseCloseStockAccountResponse() {
    return {};
}
exports.CloseStockAccountResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CloseStockAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCloseStockAccountResponse();
        return message;
    },
};
/**
 * Stock Test API Service
 */
class StockTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.proto.StockTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'CreateOrder',
            requestType: stock_testing_service_1.CreateOrderRequest,
            responseType: stock_testing_service_1.CreateOrderResponse,
            authenticationOptions: undefined,
        }, {
            name: 'AddActivity',
            requestType: stock_testing_service_1.AddActivityRequest,
            responseType: stock_testing_service_1.AddActivityResponse,
            authenticationOptions: undefined,
        }, {
            name: 'AddTestDocument',
            requestType: stock_testing_service_1.AddTestDocumentRequest,
            responseType: stock_testing_service_1.AddTestDocumentResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetIgnoreMarketHours',
            requestType: stock_testing_service_1.GetIgnoreMarketHoursRequest,
            responseType: stock_testing_service_1.GetIgnoreMarketHoursResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetIgnoreMarketHours',
            requestType: stock_testing_service_1.SetIgnoreMarketHoursRequest,
            responseType: stock_testing_service_1.SetIgnoreMarketHoursResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetGraduationTransferDelay',
            requestType: stock_testing_service_1.SetGraduationTransferDelayRequest,
            responseType: stock_testing_service_1.SetGraduationTransferDelayResponse,
            authenticationOptions: undefined,
        }, {
            name: 'CloseStockAccount',
            requestType: exports.CloseStockAccountRequest,
            responseType: exports.CloseStockAccountResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Creates a stock buy/sell order. Currently, the following supported:
     *  - buy/sell limit order
     *  - market order with quantity (for HL symbol only)
     */
    createOrder(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Add one or more simulated transactions for testing, depending on the
     * activity type.
     */
    addActivity(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Adds a test document for a user.
     */
    addTestDocument(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns value of ignoreMarketHoursForTesting flag on DriveWealth account.
     */
    getIgnoreMarketHours(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sets ignoreMarketHoursForTesting flag on DriveWealth account.
     */
    setIgnoreMarketHours(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sets graduation transfer delay for sandbox DriveWealth account.
     */
    setGraduationTransferDelay(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Request to close stock account.
     */
    closeStockAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.StockTestApiServiceClient = StockTestApiServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=stock-testapi-service.js.map